import * as React from "react"

const COUNTER_NAMESPACE = "sampson-blog-speedwares"
const COUNTER_API = "https://api.counterapi.dev/v1"

const LikeButton = ({ slug }) => {
  const [count, setCount] = React.useState(0)
  const [isLoaded, setIsLoaded] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  const counterName = `${slug
    .replace(/^\/|\/$/g, "")
    .replace(/[^a-z0-9]+/gi, "-")
    .toLowerCase()}-likes`
  const counterUrl = `${COUNTER_API}/${COUNTER_NAMESPACE}/${counterName}`

  React.useEffect(() => {
    let isCurrent = true

    fetch(`${counterUrl}/`)
      .then(response => {
        if (response.status === 400) {
          return { count: 0 }
        }

        if (!response.ok) {
          throw new Error("Unable to load likes")
        }

        return response.json()
      })
      .then(data => {
        if (isCurrent) {
          setCount(data.count)
          setIsLoaded(true)
        }
      })
      .catch(() => {
        if (isCurrent) {
          setHasError(true)
          setIsLoaded(true)
        }
      })

    return () => {
      isCurrent = false
    }
  }, [counterUrl])

  const handleLike = async () => {
    setCount(currentCount => currentCount + 1)
    setHasError(false)

    try {
      const response = await fetch(`${counterUrl}/up`)

      if (!response.ok) {
        throw new Error("Unable to save like")
      }

      const data = await response.json()
      setCount(currentCount => Math.max(currentCount, data.count))
    } catch {
      setHasError(true)
    }
  }

  return (
    <div className="post-likes">
      <button
        className="like-button"
        type="button"
        onClick={handleLike}
        aria-label="Like this post"
        title="Like this post"
      >
        <svg
          aria-hidden="true"
          className="like-button-icon"
          viewBox="0 0 24 24"
        >
          <path d="M12 21s-7.5-4.35-9.6-8.25C.65 9.5 2.05 5.5 5.8 4.65 8 4.15 10.15 5.2 12 7.2c1.85-2 4-3.05 6.2-2.55 3.75.85 5.15 4.85 3.4 8.1C19.5 16.65 12 21 12 21Z" />
        </svg>
        <span aria-live="polite">{isLoaded ? count : "…"}</span>
      </button>
      {hasError && (
        <span className="like-error" role="status">
          Couldn’t sync this like yet.
        </span>
      )}
    </div>
  )
}

export default LikeButton
